/**
 * features/Table/ui/TableTechCards.jsx
 *
 * Таблица тех. карт.
 * Показывает card_mode (Справочный / Полуавтомат / Автомат),
 * компоненты и выходные изделия.
 */
import React, { useContext, useEffect, useState } from "react";
import { message } from "antd";
import { apiRequests } from "src/shared/api/api";
import { TechCards } from "src/enitities/Table";
import { TechCardContext } from "src/shared/lib/hooks/context/getTechCardsContext";

export default function TableTechCards() {
  const { token, data, refreshData } = useContext(TechCardContext);
  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    if (data) {
      setDataSource(
        data.map(tc => ({
          ...tc,
          items_count:        tc.items        ? tc.items.length        : 0,
          output_items_count: tc.output_items ? tc.output_items.length : 0,
        }))
      );
    }
  }, [data]);

  const handleRemove = async (id) => {
    try {
      await apiRequests.tech_cards.delete(id);
      if (refreshData) await refreshData();
    } catch (err) {
      message.error("Ошибка при удалении тех. карты");
      console.error(err);
    }
  };

  return (
    <TechCards
      dataSource={dataSource}
      handleRemove={handleRemove}
      token={token}
    />
  );
}